import { render } from "./PersonList.vue?vue&type=template&id=7d5ffd3c&scoped=true&ts=true"
import script from "./personListHelper.ts?vue&type=script&lang=ts"
export * from "./personListHelper.ts?vue&type=script&lang=ts"

import "./PersonList.vue?vue&type=style&index=0&id=7d5ffd3c&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5ffd3c"]])

export default __exports__